import React from 'react'
import { string, array } from 'prop-types'
import { FormattedMessage } from 'react-intl'
import Icon from '../icon/Icon'
import { messages } from './messages'
import SpecListItem from './SpecListItem'

const SPEC_ITEM_ICON = {
  expertise: 'expertises',
  categories: 'projects',
  offices: 'architects'
}

const SpecItem = ({ data, item, landingUrl, scope }) => {
  return data && !!data.length && (
    <div className='specs__item'>
      <Icon svg={SPEC_ITEM_ICON[item]} withoutEvents withoutFill />
      <p className='list-view__object'>
        <span className='specs__key'><FormattedMessage {...messages[item]} />:&nbsp;</span>
        <SpecListItem item={item} items={data} landingUrl={landingUrl} scope={scope} />
      </p>
    </div>
  )
}

SpecItem.propTypes = {
  data: array,
  item: string,
  scope: string,
  landingUrl: string
}

export default SpecItem
